<template>
  <div class="sc_first">
    <Anonce />
    <h2>Кабинет ученика</h2>

    <Intro />

    <help-users-module v-if="userFirstVisit"></help-users-module>
    

    <div class="sc_first__grid main">
      <!-- <router-link class="contest-btn" to="/matrius">
        <i class="fas fa-award"></i> Битва Матриуса
      </router-link> -->
      <ul class="uk-child-width-1-4@s uk-grid-match uk-flex-center uk-grid-small help-module__highlight" uk-grid>
        <li>
          <router-link to="/trainers">
            <div class="maincontent__item">
              <div class="maincontent__ico">
                <img :src="'/storage/app/media/categories/n_cat1.png'" alt="">
              </div>
              <p>Тренажеры</p>
              <!--<p>Тренажеры<br>&nbsp;</p>-->
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/classes">
            <div class="maincontent__item">
              <div class="maincontent__ico">
                <img :src="'/storage/app/media/categories/n_cat2.png'" alt="">
              </div>
              <p>Мои классы</p>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/stats">
            <div class="maincontent__item">
              <div class="maincontent__ico">
                <img :src="'/storage/app/media/categories/n_cat3.png'" alt="">
              </div>
              <p>Статистика</p>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/scores">
            <div class="maincontent__item">
              <div class="maincontent__ico">
                <img :src="'/storage/app/media/categories/n_cat4.png'" alt="">
              </div>
              <p>Достижения</p>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/homework">
            <div class="maincontent__item maincontent__item--2st">
              <div class="maincontent__ico">
                <img :src="'/storage/app/media/categories/n_cat5.png'" alt="">
              </div>
              <p>Домашнее задание</p>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/lessons">
            <div class="maincontent__item">
              <div class="maincontent__ico">
                <img :src="'/storage/app/media/categories/n_cat6.png'" alt="">
              </div>
              <p>Мои занятия</p>
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/materials">
            <div class="maincontent__item">
              <div class="maincontent__ico">
                <img :src="'/storage/app/media/categories/n_cat7.png'" alt="">
              </div>
              <p>Материалы</p>
            </div>
          </router-link>
        </li>
<!--        <li v-if="!user.is_outside">
          <router-link to="/shop">
            <div class="maincontent__item maincontent__item&#45;&#45;2st">
              <div class="maincontent__ico">
                <img :src="'/storage/app/media/categories/cat8a.png'" alt="">
              </div>
              <p>Магазин подарков</p>
            </div>
          </router-link>
        </li>-->
      </ul>
    </div>
    <!--<div class="sc_first__drako" uk-scrollspy="cls:uk-animation-slide-left;delay: 300">-->
    <div class="sc_first__drako">
      <img src="storage/app/media/drak1.png" alt="">
    </div>
  </div>
</template>

<script>
import Anonce from './Anonce'
import Intro from "./Intro";
import { mapGetters } from 'vuex'

export default {
  name: "maincomponent",
  components: {
    Anonce, Intro
  },
  inject: ['site_settings'],
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    userFirstVisit(){
      // return true
      return this.user && !this.user.property.help_module_watch ? true : false
    }
  }
}
</script>